import { render, staticRenderFns } from "./errorQuestion.vue?vue&type=template&id=5a626e62&scoped=true&"
import script from "./errorQuestion.vue?vue&type=script&lang=js&"
export * from "./errorQuestion.vue?vue&type=script&lang=js&"
import style0 from "./errorQuestion.vue?vue&type=style&index=0&id=5a626e62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a626e62",
  null
  
)

export default component.exports